//  actions
import TYPES from './types'

//  initialState
import initialState from './initialState'

// Model
import model from './model'

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ZIP_CODES.FETCH.REQUEST:
      return model.customLoading(state, action.payload)
    case TYPES.ZIP_CODES.FETCH.SUCCEEDED:
      return model.saveData(state, action.payload, action.location)
    case TYPES.ZIP_CODES.FETCH.FAILED:
      return model.customError(state, action.payload)
    default:
      return state
  }
}
